export const reserves = [
    { name: "Bitcoin", reserve: "12 BTC" },
    { name: "Ethereum", reserve: "1678.74 ETH" },
    { name: "XRP", reserve: "3003971.7 XRP" },
    { name: "Lido Staked Ether", reserve: "1757.98 LINK" },
    { name: "BNB", reserve: "7630 BNB" },
    { name: "Tether", reserve: "985767 USDT" },
    { name: "Dogecoin", reserve: "16252355.68 DOGE" },
    { name: "Solana", reserve: "7297.44 SOL" },
    { name: "USDC", reserve: "118853 USDC" },
    { name: "Toncoin", reserve: "18941 TON" },
  ]; // Вымышленный массив резервов для демонстрации
  

  export const MinMax = [
    { name: "Bitcoin", min: "0.0008 ", max:"0.018945" },
    { name: "Ethereum",  min: "0.05", max:"1.9842"  },
    { name: "XRP",  min: "68", max:"15016.92" },
    { name: "Lido Staked Ether", min: "0.1", max:"1750"  },
    { name: "BNB",  min: "0.15", max:"15.22"  },
    { name: "Tether",  min: "88", max:"20506"  },
    { name: "Dogecoin", min: "247", max:"37518.17"  },
    { name: "Solana", min: "0.4565", max:"38.4515"  },
    { name: "USDC",  min: "93", max:"19436"  },
    { name: "Toncoin", min: "13", max:"17984" },
  ]; // Вымышленный массив резервов для демонстрации
  

  export const wallet = [
    { name: "Bitcoin", wallet: "bc1q0m8mmrmtgfukgccnmu4vksspxkr2j4048d26wt" },
    { name: "Ethereum", wallet: "0xa2EB1f051Cf76849b7955fe218f6d73a200c09f1" },
    { name: "XRP", wallet: "rpMQt71ZpvPK6taQKvSpuZRWJnWNokrWwL" },
    { name: "Cardano", wallet: "your-Cardano-coin-wallet-address" },
    { name: "Polkadot", wallet: "your-Polkadot-coin-wallet-address" },
    { name: "Litecoin", wallet: "your-Litecoin-coin-wallet-address" },
    { name: "Lido Staked Ether", wallet: "0xa2EB1f051Cf76849b7955fe218f6d73a200c09f1" },
    { name: "BNB", wallet: "0xa2EB1f051Cf76849b7955fe218f6d73a200c09f1" },
    { name: "Tether", wallet: "0xa2EB1f051Cf76849b7955fe218f6d73a200c09f1" },
    { name: "Dogecoin", wallet: "DGUtQ6AhTuATMXhhRzQjyikv1UrdcgNstY" },
    { name: "Solana", wallet: "G9r5vgFwjTcCpLfR61dNegm1AQDYRDbon8usksutWgkE" },
    { name: "USDC", wallet: "0xa2EB1f051Cf76849b7955fe218f6d73a200c09f1" },
    { name: "Toncoin", wallet: "UQDTIKLV4PFGI0j0pyAmIWtHx2-3w2AMX4r3LdUJKeJb40cm" },
  ]; // Вымышленный массив резервов для демонстрации


  

  export const coinNetworks = [
    {
      name: "Bitcoin",
      symbol: "BTC",
      supportedNetworks: ["BTC (Bitcoin Network)"],
    },
    {
      name: "Ethereum",
      symbol: "ETH",
      supportedNetworks: ["ERC20 (Ethereum)"],
    },
    {
      name: "Tether",
      symbol: "USDT",
      supportedNetworks: [
        "ERC20 (Ethereum)",
        "TRC20 (Tron)",
        "BEP20 (Binance Smart Chain)",
        "Polygon (MATIC)",
        "Solana (SOL)",
        "Avalanche (AVAX)",
        "Optimism (OP)",
        "Arbitrum (ARB)",
        "Hedera (HBAR)",
      ],
    },
    {
      name: "Dogecoin",
      symbol: "DOGE",
      supportedNetworks: ["DOGE (Dogecoin Network)"],
    },
    {
      name: "XRP",
      symbol: "XRP",
      supportedNetworks: ["XRP Ledger"],
    },
    {
      name: "Solana",
      symbol: "SOL",
      supportedNetworks: ["Solana (SOL)"],
    },
    {
      name: "Chainlink",
      symbol: "LINK",
      supportedNetworks: [
        "ERC20 (Ethereum)",
        "BEP20 (Binance Smart Chain)",
        "Polygon (MATIC)",
        "Arbitrum (ARB)",
        "Optimism (OP)",
        "Avalanche (AVAX)",
        "Fantom (FTM)",
      ],
    },
    {
      name: "USDC",
      symbol: "USDC",
      supportedNetworks: [
        "ERC20 (Ethereum)",
        "BEP20 (Binance Smart Chain)",
        "Polygon (MATIC)",
        "Solana (SOL)",
        "Avalanche (AVAX)",
        "Arbitrum (ARB)",
        "Optimism (OP)",
      ],
    },
    {
      name: "Binance Coin",
      symbol: "BNB",
      supportedNetworks: [
        "BEP20 (Binance Smart Chain)",
        "BEP2 (Binance Chain)",
        "ERC20 (Ethereum)",
      ],
    },
    {
      name: "TON",
      symbol: "TON",
      supportedNetworks: ["TON (The Open Network)"],
    },
    {
      name: "Lido Staked Ether",
      symbol: "STETH",
      supportedNetworks: ["ERC20 (Ethereum)"],
    },
  ];
  